import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff, FiLock } from "react-icons/fi";
import classes from "./ChangePassword.module.css";

const PasswordField = ({ label, value, onChange, show, toggle }) => (
  <label className={classes.field}>
    <span>{label}</span>
    <div className={classes.inputWrap}>
      <FiLock />
      <input
        className="inputBase"
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
      />
      <button type="button" className={classes.eye} onClick={toggle}>
        {show ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
  </label>
);

export default function ChangePassword({
  open,
  onClose,
  onSubmit,
  loading = false,
}) {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setShowCurrent(false);
      setShowNew(false);
      setShowConfirm(false);
    }
  }, [open]);

  if (!open) return null;

  const update = (name) => (event) =>
    setForm((prev) => ({ ...prev, [name]: event.target.value }));

  return (
    <div className={classes.overlay} onMouseDown={onClose}>
      <div className={classes.modal} onMouseDown={(e) => e.stopPropagation()}>
        <h3>Change Password</h3>
        <div className={classes.body}>
          <PasswordField
            label="Current Password"
            value={form.currentPassword}
            onChange={update("currentPassword")}
            show={showCurrent}
            toggle={() => setShowCurrent((v) => !v)}
          />
          <PasswordField
            label="New Password"
            value={form.newPassword}
            onChange={update("newPassword")}
            show={showNew}
            toggle={() => setShowNew((v) => !v)}
          />
          <PasswordField
            label="Confirm Password"
            value={form.confirmPassword}
            onChange={update("confirmPassword")}
            show={showConfirm}
            toggle={() => setShowConfirm((v) => !v)}
          />
        </div>
        <div className={classes.actions}>
          <button type="button" className="btnBase btnSecondary" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="btnBase btnPrimary"
            disabled={loading}
            onClick={() => onSubmit?.(form, setForm)}
          >
            {loading ? "Saving..." : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
}
